













import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import { Component } from 'vue-property-decorator';
import ArtistDisplay from '@/components/galleries/ArtistDisplay.vue';
import TimeRange from '@/components/filters/TimeRange.vue';
import {
    MuArtist,
    TimeRangeBucket,
} from '@/store/artists/types';

const { mapState } = createNamespacedHelpers('artists');

@Component({
    components: {
        ArtistDisplay,
        TimeRange,
    },
    computed: {
        ...mapState([
            'bucket',
        ]),
    },
})
export default class ArtistGallery extends Vue {
    'bucket': TimeRangeBucket;

    get artists(): MuArtist[] {
        return this.$store.getters[`artists/${this.bucket}`];
    }
}

